import { dataHooks } from '@wix/data-hooks';

export const headerFullPageDataHooks = dataHooks<{
  title;
  secondaryTitle;
  agentAvatar;
  resetChatButton;
  announcementBanner;
  toggleMute;
  endLiveChat;
}>('header');
